module.exports = __webpack_public_path__ + "assets/img/generavimas.00c13614.jpg";